const MAP_DRAWING_ZONE = 'DRAW_DRIWING_ZONE';
// services
const MAP_SERVICES_SOURCE_ID = 'services';
const MAP_SERVICES_POLYGON_LAYER = 'services-polygon-layer';
const MAP_SERVICES_CLUSTER_LAYER = 'services-cluster-layer';
const MAP_SERVICES_CLUSTER_SYMBOL_LAYER = 'services-cluster-symbol-layer';
const MAP_SERVICES_UNCLUSTER_LAYER = 'services-uncluster-layer';
const MAP_SERVICES_UNCLUSTER_ICON = 'services-uncluster-icon';
// addresses
const MAP_ADDRESS_SOURCE_ID = 'addresses';
const MAP_ADDRESS_CLUSTER_LAYER = 'addresses-cluster-layer';
const MAP_ADDRESS_UNCLUSTER_LAYER = 'addresses-uncluster-layer';
const MAP_ADDRESS_CLUSTER_SYMBOL_LAYER = 'addresses-cluster-symbol-layer';

// clusters color
const CLUSTER_BLUE_COLOR = '#01254E';
const CLUSTER_GREEN_COLOR = '#10B987';
const CLUSTER_RED_COLOR = '#EC5D57';
const CLUSTER_GRAY_COLOR = '#99A8B8';


const MARKER_STATUS_2 = 2;
const MARKER_STATUS_3 = 3;
const MARKER_STATUS_4 = 4;
const MARKER_STATUS_5 = 5;
const MARKER_STATUS_7 = 7;
const MARKER_SAME_POSITION = 'MARKER_SAME_POSITION';


const mapIcons = [
    {url: "icons/2.png", id: MARKER_STATUS_2},
    {url: "icons/3.png", id: MARKER_STATUS_3},
    {url: "icons/4.png", id: MARKER_STATUS_4},
    {url: "icons/5.png", id: MARKER_STATUS_5},
    {url: "icons/7.png", id: MARKER_STATUS_7},
    {url: "icons/MARKER_SAME_POSITION.png", id: 'MARKER_SAME_POSITION'},
]


export {
    MAP_DRAWING_ZONE,
    MAP_SERVICES_SOURCE_ID,
    MAP_SERVICES_POLYGON_LAYER,
    MAP_SERVICES_CLUSTER_LAYER,
    MAP_SERVICES_CLUSTER_SYMBOL_LAYER,
    MAP_SERVICES_UNCLUSTER_LAYER,
    MAP_SERVICES_UNCLUSTER_ICON,
    MAP_ADDRESS_SOURCE_ID,
    MAP_ADDRESS_CLUSTER_LAYER,
    MAP_ADDRESS_UNCLUSTER_LAYER,
    MAP_ADDRESS_CLUSTER_SYMBOL_LAYER,
    CLUSTER_BLUE_COLOR,
    CLUSTER_GREEN_COLOR,
    CLUSTER_RED_COLOR,
    CLUSTER_GRAY_COLOR,
    MARKER_STATUS_2,
    MARKER_STATUS_3,
    MARKER_STATUS_4,
    MARKER_STATUS_5,
    MARKER_STATUS_7,
    MARKER_SAME_POSITION,
    mapIcons
}